/* eslint-disable no-plusplus */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dineInCart: [],
  dineInCartUpdated: false,
};

const dineInCartSlice = createSlice({
  name: 'dineInCart',
  initialState,
  reducers: {
    addToDineInCart: (state, action) => {
      const product = action.payload;
      const existingProduct = state.dineInCart.find((item) => item.productId === product.productId);

      if (!existingProduct) {
        state.dineInCart.push({ ...product, quantity: 1 });
      } else {
        existingProduct.quantity++;
      }
      state.dineInCartUpdated = true;
    },
    removeFromDineInCart: (state, action) => {
      state.dineInCart = state.dineInCart.filter((item) => item.productId !== action.payload.id);
      state.dineInCartUpdated = true;
    },
    clearDineInCart: (state) => {
      state.dineInCart = [];
      state.dineInCartUpdated = true;
    },
    setDineInCart: (state, action) => {
      state.dineInCart = action.payload;
      state.dineInCartUpdated = true;
    },
    resetDineInCartUpdated: (state) => {
      state.dineInCartUpdated = false;
    },
  },
});

export const {
  addToDineInCart,
  removeFromDineInCart,
  clearDineInCart,
  setDineInCart,
  resetDineInCartUpdated,
} = dineInCartSlice.actions;

export default dineInCartSlice.reducer;
